import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal();

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page main">
        <div className="cart-container">
          <h1 className="cart-title">SHOPPING CART</h1>
          <p>Your cart is currently empty.</p>
          <Link onClick={toTop} to="/shop" className="continue-shopping">
            Continue shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page main">
      <div className="cart-container">
        <h1 className="cart-title">SHOPPING CART</h1>

        <div className="cart-content">
          <div className="cart-items-section">
            {cartItems.map((item, index) => {
              const product = getProductById(item.id);
              if (!product) return null;

              const itemTotal = (
                parseFloat(product.price.replace(/,/g, "")) * item.quantity
              ).toFixed(2);

              return (
                <div className="cart-item" key={index}>
                  <div className="item-image-wrapper">
                    <Link onClick={toTop} to={`/shopDetails/${product.id}`}>
                      <img
                        src={product.cartImage}
                        alt={product.name}
                        className="item-image"
                      />
                    </Link>
                  </div>

                  <div className="item-details">
                    <div className="item-header">
                      <Link
                        onClick={toTop}
                        to={`/shopDetails/${product.id}`}
                        className="item-name"
                      >
                        {product.name.toUpperCase()}
                      </Link>
                      <button
                        className="remove-btn"
                        onClick={() =>
                          removeFromCart(item.id, item.size, item.color)
                        }
                      >
                        Remove &times;
                      </button>
                    </div>

                    <p className="item-price">${product.price}</p>

                    {(item.color || item.size) && (
                      <div className="item-options">
                        {item.color && (
                          <span className="item-option">
                            Color: {item.color}
                          </span>
                        )}
                        {item.size && (
                          <span className="item-option">Size: {item.size}</span>
                        )}
                      </div>
                    )}

                    <div className="item-actions">
                      <div className="quantity-selector">
                        <button
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity - 1
                            )
                          }
                          className="qty-btn"
                        >
                          &minus;
                        </button>
                        <input
                          type="text"
                          value={item.quantity}
                          readOnly
                          className="qty-input"
                        />
                        <button
                          onClick={() =>
                            handleUpdateQuantity(
                              item.id,
                              item.size,
                              item.color,
                              item.quantity + 1
                            )
                          }
                          className="qty-btn"
                        >
                          +
                        </button>
                      </div>
                    </div>

                    <p className="item-total">
                      <strong>Total:</strong> ${itemTotal}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="cart-summary-section">
            <div className="summary-row">
              <span className="summary-label">Subtotal</span>
              <span className="summary-value">${subtotal.toFixed(2)}</span>
            </div>

            <p className="summary-note">
              Shipping is a flat $9.99 USD and is added at checkout.
            </p>
            <p className="summary-note">Orders are processed in USD.</p>

            <div className="order-notes">
              <label>Order Notes:</label>
              <textarea rows="4"></textarea>
            </div>

            <p className="thanks-note">Thanks so much for shopping with us</p>

            <button className="checkout-btn" onClick={handleCheckout}>
              <svg
                viewBox="0 0 24 24"
                width="16"
                height="16"
                stroke="currentColor"
                strokeWidth="2"
                fill="none"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="lock-icon"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
              CHECKOUT
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
